import {
  backgroundColorCss,
  colorCss,
  mobileBackgroundColorCss,
  mobileColorCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

export interface TwoStepPaymentFormHeaderItemUiProps {
  active: boolean
  headerUnderlineColor: string
  backgroundColor?: string
  mobileBackgroundColor?: string
  color: string
  mobileColor?: string
}

const TwoStepPaymentFormHeaderItemUi = styled.div<TwoStepPaymentFormHeaderItemUiProps>`
  position: relative;
  ${p =>
    p.active &&
    css`
      &::before {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 49%;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid ${p.headerUnderlineColor};
      }
    `};
  display: flex;
  flex-basis: 50%;

  ${colorCss}
  ${backgroundColorCss}

  ${p => p.theme.phone} {
    ${mobileColorCss}
    ${mobileBackgroundColorCss}
  }

  padding: 15px;
  border-bottom: 5px solid ${p => p.headerUnderlineColor};
`

export default TwoStepPaymentFormHeaderItemUi
